import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthResetPassword } from '@lightning/ui';
import { resolvePasswordRecoverySession } from '@lightning/services/auth';
import { toast } from 'sonner';
import { howieAuthBrand } from '../config/authBrand';
import { supabase } from '../services/supabase';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      const { error } = await resolvePasswordRecoverySession(supabase);

      if (!isMounted) return;

      if (error) {
        toast.error(error.message || 'Invalid or expired reset link');
        navigate('/login', { replace: true });
        return;
      }

      setIsVerifying(false);
    };

    void checkAuth();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <AuthResetPassword
      brand={howieAuthBrand}
      isVerifying={isVerifying}
      onSubmit={async (password) => {
        const { error } = await supabase.auth.updateUser({ password });
        if (error) throw error;
        toast.success('Password updated successfully');
      }}
      onSubmitError={(error) => {
        console.error('[Howie] Password update error:', error);
        toast.error(error instanceof Error ? error.message : 'An unexpected error occurred');
      }}
      onValidationError={(message) => toast.error(message)}
      onNavigateToSignIn={() => navigate('/login')}
    />
  );
}
